export default __webpack_public_path__ + "media/images/carousel/02-5f0d480fe1d6fed071c603846ade8774.jpg";